export enum UserPermissionType {
  SETTINGS = 'settings',
  SETTINGS_BRANCHES = 'settings_branches',
  FINANCIAL_REPORTS = 'financial_reports',
  ACCOUNTING = 'accounting',
  EDUCATION = 'education',
  REGISTRATION_AND_COLLECTION = 'registration_and_collection',
}
